import React, { useState, useEffect, useCallback } from 'react';
import {
    Box, Card, CardContent, Grid, Typography, Tabs, Tab
} from '@mui/material';
import { Icon } from '@iconify/react';
import IndividualPost from './IndividualPost';
import { CampaignCardProps } from '../types/apps/Campaign';

const CampaignCard: React.FC<CampaignCardProps> = ({ campaign }) => {
    const [currentTab, setCurrentTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={8}>
                <Card sx={{ mb: 2 }}>
                    <CardContent>
                        <Tabs value={currentTab} onChange={handleTabChange}>
                            <Tab label="Scheduled" />
                            <Tab label="Delivered" />
                            <Tab label="Draft" />
                            <Tab label="Pending Approval" />
                        </Tabs>
                    </CardContent>
                    {currentTab === 0 &&
                        <CardContent>
                            {campaign?.posts?.filter(p => p.postStatus === 1).map((post) => (
                                <IndividualPost key={post.id} post={post} campaign={campaign} />
                            ))}
                        </CardContent>
                    }
                    {currentTab === 1 &&
                        <CardContent>
                            {campaign?.posts?.filter(p => p.postStatus === 2).map((post) => (
                                <IndividualPost key={post.id} post={post} campaign={campaign} />
                            ))}
                        </CardContent>
                    }
                    {currentTab === 2 &&
                        <CardContent>
                            {campaign?.posts?.filter(p => p.postStatus === 4).map((post) => (
                                <IndividualPost key={post.id} post={post} campaign={campaign} />
                            ))}
                        </CardContent>
                    }
                    {currentTab === 3 &&
                        <CardContent>
                            {campaign?.posts?.filter(p => p.postStatus === 5).map((post) => (
                                <IndividualPost key={post.id} post={post} campaign={campaign} />
                            ))}
                        </CardContent>
                    }
                </Card>
            </Grid>
            <Grid item xs={4}>
                <Card sx={{ mb: 2, p: 2, borderRadius: '5px', boxShadow: 3 }}>
                    <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box>
                                <Typography variant="h6" sx={{ mb: 1 }}>{campaign.name}</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Icon icon="mdi:calendar" color="action" />
                                    <Typography variant="body2" color="textSecondary">{campaign.length}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                    <Icon icon="mdi:clock-time-four" color="action" />
                                    <Typography variant="body2" color="textSecondary">{campaign.scheduledPosts} Scheduled</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                    <Icon icon="icon-park-solid:message-sent" color="action" />
                                    <Typography variant="body2" color="textSecondary">{campaign.sentPosts} Sent</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default CampaignCard;